export default [
	{
		path: "/pros/discounts",
		exact: true,
		policy: "providerAuth",
		component: "Discounts",
		mui: true,
	},
];
